// Pure port of the charts-model transform that block.coffee built inline
// (OpenEnded#renderChartsModel and Conversation#_renderChartsModel). The impure
// half — resolving the tag / sentiment name list out of page.model + window.survey —
// stays with the caller; everything below takes the resolved names and builds the
// { answer, answerVariants } pair the chart and items list consume.
// import { encodeText } from '@aytm/app/stats/lib/util/helpers'

export const CHART_VIEW_MODES = ['sentiments', 'tags']

const AV_KEY_REG = /^a\d+$/

// sentiments read their own answer slice; tags read the selected codebook, falling
// back to the first one when the config names none.
export const selectTagsAnswer = (viewMode, answer, config) => {
  if ('tags' !== viewMode) return answer?.[viewMode] || {}

  const codeBooks = answer?.codeBooks
  if (!config?.codebook) return codeBooks?.[0] || {}

  return codeBooks?.find(codebook => config.codebook === codebook.title) || {}
}

export const emptyChartsModel = () => ({ answer: { total: 0 }, answerVariants: [] })

// `keys` is the resolved sentiment / tag name list, in display order. Every name gets
// a slot even when the payload carries no matching tag, so positions stay stable.
export const buildChartsModel = ({ viewMode, answer, keys = [], codebook = null }) => {
  const isSentiments = 'sentiments' === viewMode

  const _answer = keys.reduce((acc, cur, i) => {
    const slot = structuredClone(answer?.tags?.find(tag => tag.tag === cur) || { amount: 0 })
    slot.comments = slot.amount || 0
    acc[`a${i + 1}`] = slot
    return acc
  }, {})
  _answer.total = answer?.total || 0

  const answerVariants = keys.map((v, i) => ({
    tag: codebook ? `${codebook}: ${v}` : v,
    text: v,
    // the filter and comments handlers key off this: without it they fall back to filtering
    // by answer position, which these rows do not have -- they are tags
    type: isSentiments ? 'sentiment' : 'tag',
    path: isSentiments ? ['sentiment'] : ['tag'],
    filter: isSentiments ? 'tag.sentiment' : 'tag',
    comments: 0 < _answer[`a${i + 1}`].amount,
    position: i + 1
  }))

  return { answer: _answer, answerVariants }
}

// Conversation's extra `chart` view mode: positions come from the answer's own a{n}
// keys rather than a tag list, and labels are looked up on the delivered variants.
export const buildConversationChartModel = ({ answer, answerVariants = [] }) => {
  const _source = answer || {}
  const keys = Object.keys(_source).filter(v => AV_KEY_REG.test(v))

  const _answer = keys.reduce((acc, cur, i) => {
    const slot = structuredClone(_source[cur] || { amount: 0 })
    slot.comments = slot.amount || 0
    acc[`a${i + 1}`] = slot
    return acc
  }, {})
  _answer.total = _source.total || 0

  const _answerVariants = keys.map((v, i) => {
    const av = (answerVariants || []).find(item => item.position === Number(v.slice(1)))
    return {
      text: av?.text || '',
      path: [],
      filter: i + 1,
      comments: 0 < _answer[`a${i + 1}`].amount,
      position: i + 1
    }
  })

  return { answer: _answer, answerVariants: _answerVariants }
}
